import { Ticket as TicketIcon, CheckCircle2, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Selección de motivo de cortesía (caseta) — presentacional.
export const CortesiaDialog = ({
  cortesiaOpen, setCortesiaOpen, cortesiaMotivo, setCortesiaMotivo, motivosCortesia,
  aplicarCortesiaTerminal, coPaying,
}) => (
  <Dialog open={cortesiaOpen} onOpenChange={(o) => { if (!o) { setCortesiaOpen(false); setCortesiaMotivo(""); } }}>
    <DialogContent className="rounded-none border-[#A78BFA]/40 bg-[#0A0A0A] text-white max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="terminal-cortesia-modal">
      <DialogHeader>
        <div className="h-12 w-12 bg-[#A78BFA]/15 border border-[#A78BFA]/40 flex items-center justify-center mb-2">
          <TicketIcon className="h-6 w-6 text-[#A78BFA]" />
        </div>
        <DialogTitle className="font-display font-black text-white text-xl">Aplicar Cortesía</DialogTitle>
        <DialogDescription className="text-white/50">El total se cobrará en $0.00. Selecciona un motivo (queda registrado con tu usuario).</DialogDescription>
      </DialogHeader>
      <div className="space-y-2 py-1">
        {motivosCortesia.map((m) => (
          <button key={m} onClick={() => setCortesiaMotivo(m)} data-testid={`terminal-cortesia-motivo-${m}`}
            className={`w-full h-11 px-3 text-left text-sm font-bold uppercase tracking-wide border flex items-center justify-between transition-colors ${cortesiaMotivo === m ? "border-[#A78BFA] bg-[#A78BFA]/15 text-[#A78BFA]" : "border-white/15 text-white/70 hover:border-white/30"}`}>
            {m} {cortesiaMotivo === m && <CheckCircle2 className="h-4 w-4" />}
          </button>
        ))}
        {motivosCortesia.length === 0 && <p className="text-white/40 text-sm text-center py-4">No hay motivos configurados.</p>}
      </div>
      <div className="flex gap-2 pt-1">
        <button onClick={() => { setCortesiaOpen(false); setCortesiaMotivo(""); }} data-testid="terminal-cortesia-cancelar"
          className="btn-hard flex-1 h-11 bg-white/5 border border-white/20 text-white/70 font-bold uppercase tracking-wider hover:bg-white/10">Cancelar</button>
        <button onClick={aplicarCortesiaTerminal} disabled={coPaying || !cortesiaMotivo} data-testid="terminal-cortesia-confirmar"
          className="btn-hard flex-1 h-11 bg-[#A78BFA] text-[#0A0A0A] border border-[#A78BFA] font-black uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-50">
          {coPaying ? <Loader2 className="h-4 w-4 animate-spin" /> : "Confirmar $0.00"}
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default CortesiaDialog;
